export default {"src":"/_next/static/media/favicon.c467bf76.ico","height":64,"width":64};